import { createContext } from 'react';

export type APIUsageContextType = {
  llm: any;
  setLLM: (data: any) => void;
};

export const APIUsageContext = createContext<APIUsageContextType>({
  llm: null,
  setLLM: (data) => {},
});
